/**
 * Svelte action for accessibility.  Adds both click and Enter/Space keyboard handlers.
 *
 * @example <div use:clickOrEnter={() => doSomething()} tabindex="0" role="button">
 */
export function clickOrEnter(node, callback) {
  function handleKeydown(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      callback();
    }
  }

  node.addEventListener('click', callback);
  node.addEventListener('keydown', handleKeydown);

  return {
    update(newCallback) {
      node.removeEventListener('click', callback);
      callback = newCallback;
      node.addEventListener('click', callback);
    },
    destroy() {
      node.removeEventListener('click', callback);
      node.removeEventListener('keydown', handleKeydown);
    },
  };
}
